﻿import React from 'react';
import KnowledgeAssistant from '../knowledge/KnowledgeAssistant';
import DocumentHead from '../shared/DocumentHead';
import { useSearchParams } from 'react-router-dom';

const KnowledgeAssistantPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const searchText = searchParams.get('searchText');

    return (
        <>
            <DocumentHead
                title='Knowledge assistant'
                description='Get assistance from our smart knowledge assistant'
            />
            <KnowledgeAssistant initialQuery={searchText || undefined} />
        </>
    );
};

export default KnowledgeAssistantPage;
